import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const BlankLabelSheet = React.forwardRef(({ items }, ref) => (
  <div ref={ref} style={{ width: '200px', height: '400px', backgroundColor: 'white', position: 'relative', overflow: 'hidden', boxSizing: 'border-box' }}>
    <div style={{ width: '400px', height: '200px', position: 'absolute', top: 0, left: '200px', transformOrigin: '0 0', transform: 'rotate(90deg)', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gridTemplateRows: 'repeat(2, 1fr)', boxSizing: 'border-box', padding: '10px 5px', fontFamily: "'Sarabun', sans-serif", color: 'black' }}>
      {items.map((item, idx) => (
        <div key={idx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', padding: '2px', border: '1px dashed #eee' }}>
          <QRCodeCanvas value={item.unique_barcode} size={70} level="M" />
          <div style={{ fontSize: '12px', marginTop: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{item.unique_barcode}</div>
        </div>
      ))}
    </div>
  </div>
));

export default BlankLabelSheet;
